<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4Fc9dn/images/e9781439626405_cover.jpg?1684245184948" alt="This image is the cover for the book Downtown Silver Spring, Then and Now"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Downtown Silver Spring, Then and Now
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Take a tour of the dynamic central business district of Silver Spring, Maryland, and its surroundings.</b></p><br/><p>In 1840, journalist and politician Francis Preston Blair discovered a sparkling mica-flecked spring that would serve as the centerpiece of his country estate, Silver Spring. In just over a century, this bucolic woodland, located across the border from Washington, D.C., became known as downtown Silver Spring, Maryland. Author Jerry A. McCoy, founder and president of the Silver Spring Historical Society and a special collections librarian at the D.C. Public Library's Washingtoniana Division and Peabody Room, takes you inside of how it came to be.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jerry A. McCoy, , George Pelecanos
      </h2>
      
      <p class="authorDescription body article">Author Jerry A. McCoy, founder and president of the Silver Spring Historical Society and a special collections librarian at the D.C. Public Library's Washingtoniana Division and Peabody Room, offers readers a tour of this dynamic central business district and surrounds.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5800db6e